import React, { Component } from "react";
import BarraLateral from "../../../../componentes/BarraLateral";
import InputPadrao from "../../../../componentes/Inputs/ImputPadrao";
import BotaoPadrao from "../../../../componentes/Botoes/BotaoPadrao";
//import TooglePadrao from "../../../../componentes/Botoes/TooglePadrao";
//import InputDataPadrao from "../../../../componentes/Inputs/InputDataPadrao";
import TituloPagina from "../../../../componentes/TituloPagina";
import TituloCadastroDetalhe from "../../../../componentes/Titulos/TituloCadatrosDetalhe";
import MsgPopUpPadrao from "../../../../componentes/PopUpModal/MsgPopUpPadrao";
//import ComboBoxPadrao from "../../../../componentes/ComboBox/ComboboxPadrão"
//import ImputNumeroPadrao from "../../../../componentes/Inputs/ImputNumeroPadrao"
//import ContainerFiltro from "../../../../componentes/ContainerFiltro";
import Rodape from "../../../../componentes/Rodape";
import { Global_Retorna_Permissoes, Global_Retorna_Usuario } from "../../../../Funcoes_Globais";
import withRouter from "../../../../Rotas/rotasParametros";
import Api from '../../../../servicos/Axios';
import Estilos from "./estilo.module.css";
import PopUpLoadPadrao from '../../../../componentes/PopUpLoad/PopUpLoadPadrao';
import TabelaPadrao from "../../../../componentes/Tabelas/TabelaPadrao";

//https://www.freecodecamp.org/news/jwt-authentication-in-flask/

class DespesaCadastro extends Component{    
    constructor(props){
        super(props)

        this.state = {
            State_MsgPopUpPadrao_Visivel: false,
            State_MsgPopUpPadrao_Mensagem: '',
            State_MsgPopUpPadrao_Tipo: 1,
            State_MsgPopUpPadrao_Acao: '',
            State_MsgPopUpPadrao_Mostrar_Botoes: true,

            State_LoadPopUpPadrao_Visivel: false,
            State_LoadPopUpPadrao_Mensagem: '',
            
            State_Permissao_Editar: Global_Retorna_Permissoes('config_perm', 'editar'),
            State_Permissao_Ver: Global_Retorna_Permissoes('config_perm', 'ver'),
            State_Permissao_cadastrar: Global_Retorna_Permissoes('config_perm', 'cadastrar'),
            State_Login_Revenda: Global_Retorna_Usuario('login_revenda'),

            state_status_operacao: this.props.match.paramsLocation.state.status_operacao ,
            state_log_id: this.props.match.paramsLocation.state.log_id,            
            state_log_tipo: '',
            state_log_data: null,
            state_log_mensgem: '',
            state_log_servico: '',
            state_log_rotina: '',
            state_log_numero_linha: '',
            state_log_lista_visualizacoes: [],
        };
        
        //https://stackoverflow.com/questions/70143135/how-to-use-react-router-dom-v6-navigate-in-class-component
        //O Match pega o parâmetro passado de outra tela pelo link, o navegar navega entre as telas
        //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>");
        //console.log(this.props.match)         
        //console.log(this.props.match.paramsLocation.state.cliente_id);      
        //console.log(this.props.match.paramsLocation.state.status_operacao);

    };

    componentDidMount (){
        this.Pesquisar_Logs();                  
    };   

    Abre_MsgPopUpPadrao(Tipo = 1, Mostrar_botoes = true, Mensagem = '', Acao_Botao = '', Tempo_fechar = 0){
        this.setState({
            State_MsgPopUpPadrao_Visivel: true,
            State_MsgPopUpPadrao_Tipo: Tipo,
            State_MsgPopUpPadrao_Mensagem: Mensagem,
            State_MsgPopUpPadrao_Acao: Acao_Botao, 
            State_MsgPopUpPadrao_Mostrar_Botoes: Mostrar_botoes,  
        }, () => {
            if (Tempo_fechar > 0){
                setTimeout(
                    this.Fecha_MsgPopUpPadrao.bind(this, 'timer'),
                    Tempo_fechar
                );                
            };
        });
    };

    Fecha_MsgPopUpPadrao(Tipo_botao){
        this.setState({
            State_MsgPopUpPadrao_Visivel: false,               
        }, () => {
            //
        });
    }; 
    
    Abre_LoadPopUpPadrao(mensagem){
        this.setState({
            State_LoadPopUpPadrao_Visivel: true,
            State_LoadPopUpPadrao_Mensagem: mensagem,            
        });
    };

    Fecha_LoadPopUpPadrao(){
        this.setState({
            State_LoadPopUpPadrao_Visivel: false,
            State_LoadPopUpPadrao_Mensagem: '',            
        });
    }; 

    Pesquisar_Logs(){
        var objJson = { 
            Pesq_Codigo: this.state.state_log_id,
        };
        
        this.Abre_LoadPopUpPadrao('Por favor aguarde ...');
        
        Api.Executa_chamada(
            this.props.navegar, 'Log_Servico_Detalhe', 0, JSON.stringify(objJson)
        ).then((resposta) => {

            this.Fecha_LoadPopUpPadrao();
            if (resposta.status === 1){
                this.setState({
                    state_log_id: resposta.dados.logs.codigo,
                    state_log_data: resposta.dados.logs.dt_cadastro,                    
                    state_log_tipo: resposta.dados.logs.tipo,
                    state_log_mensgem: resposta.dados.logs.mensgem,
                    state_log_servico: resposta.dados.logs.servico,
                    state_log_rotina: resposta.dados.logs.rotina,
                    state_log_numero_linha: resposta.dados.logs.numero_linha,
                    state_log_lista_visualizacoes: resposta.dados.visualizacoes,
                }, function (){
                    //
                });
            }else if (resposta.status === 2){
                this.Abre_MsgPopUpPadrao(3, false, resposta.msg, '', 2000)           
            }
            else{
                this.Abre_MsgPopUpPadrao(5, false, resposta.msg, '', 5000)
            };           
        });        
    };    
        
    render(){
        return(
        <div>
            <MsgPopUpPadrao
                visivel = {this.state.State_MsgPopUpPadrao_Visivel}
                mensagem = {this.state.State_MsgPopUpPadrao_Mensagem}
                tipo = {this.state.State_MsgPopUpPadrao_Tipo}
                mostrar_botoes = {this.state.State_MsgPopUpPadrao_Mostrar_Botoes}
                onclick_btn_ok = {this.Fecha_MsgPopUpPadrao.bind(this, 'ok')}
                onclick_btn_sim = {this.Fecha_MsgPopUpPadrao.bind(this, 'sim')}
                onclick_btn_nao = {this.Fecha_MsgPopUpPadrao.bind(this, 'nao')}
            />
            <PopUpLoadPadrao
                visivel = {this.state.State_LoadPopUpPadrao_Visivel}
                mensagem = {this.state.State_LoadPopUpPadrao_Mensagem}
            />                                 
            <BarraLateral/>
            <div className="GlobalConteinerPrincipal"> 
                <div className="GlobalConteudoPrincipal">

                    <TituloPagina titulo={"Log Serviços > Cadastro"} />
                    <TituloCadastroDetalhe titulo={"Geral"} />                 
                    <div className={Estilos.ContainerGrid}>
                        <InputPadrao 
                            titulo={'Código'}
                            value = {this.state.state_log_id}
                            disabled = {false}  
                        />
                        <InputPadrao 
                            titulo={'Data'}
                            value = {this.state.state_log_data}
                            disabled = {false} 
                        />                        
                        <InputPadrao 
                            titulo={'Tipo'}
                            value = {this.state.state_log_tipo}
                            disabled = {false} 
                        /> 
                        <InputPadrao 
                            titulo={'Serviço'}
                            value = {this.state.state_log_servico}
                            disabled = {false} 
                        /> 
                        <InputPadrao 
                            titulo={'Rotina'}
                            value = {this.state.state_log_rotina}
                            disabled = {false} 
                        /> 
                        <InputPadrao 
                            titulo={'Linha'}
                            value = {this.state.state_log_numero_linha}
                            disabled = {false} 
                        />                                                                                                                                                                                             
                    </div>                   
                    <InputPadrao 
                        titulo={'Mensagem'}
                        value = {this.state.state_log_mensgem}
                        disabled = {false}
                    />
                    <TituloCadastroDetalhe titulo={"Visualizações"} />                      
                    <TabelaPadrao
                        estilo = {{marginTop: '0px', height: '13em'}}
                        transbordarY={true}
                        estilo2 = {{marginTop: '5px'}}
                        titulo={''}
                        Itens = {this.state.state_log_lista_visualizacoes}
                        motrarBtnExcluir = {false}
                        clickExcluir ={this.Excluir_Webhook_Url}
                    />                                                                                              
                    <div className={Estilos.ConteinerBotoes} >
                        <BotaoPadrao 
                            tipo={"voltar"} 
                            descricao={"Voltar"} 
                            onClick={() =>{this.props.navegar(-1)}} 
                        />               
                    </div>                                                                                                   
                </div>
            </div>
            <Rodape/>
        </div>            
        );
    };
};

export default withRouter(DespesaCadastro);